export const iconButtonStyle = {
    backgroundColor: '#486583',
    color: '#fff',
    marginRight: 4
}

export const iconStyle = {
    fontSize: '1.5rem',
    padding: 2
}

export const undoRedoStyle = {
    // position: 'fixed',
    // right: '60px',
    // top: '10px',
    zIndex: 99
}

export const contextMenuStyle = {
    display: 'block',
    padding: 5,
    backgroundColor: '#fff',
    width: 300,
    cursor: 'pointer',
    border: '1px solid #000',
    boxShadow: '10px 6px 5px #ccc',
}

export const contextMenuItemStyle = {
    display: 'block',
    padding: 3,
    borderBottom: '1px dashed #ccc',
    '&:hover': {
        backgroundColor: "#efefef"
    },
    '&:last' : {
        border: 'none'
     }
}

export const eventListStyle = {
    padding: 10,
    width: '100%',
    border: 'solid 1px',
    backgroundColor: '#cde5ff',
    marginTop: 10
}

export const editIconStyle = {
    top: '50px'
}

export const iconBasicStyles = {
    color: '#fff',
    size: 12,
    cursor: 'pointer'
}

export const iconButtonBasicStyles = {
    border: 'none',
    
}

export const marginBottom = {
    marginBottom: 20
}

export const marginBottomForBreadCrumb = {
    marginBottom: 20
}

export const tableTdIconStyles = {
    fontSize: 20,
   
}

export const glowSettings = {
    color: 'red',
    width: 5
}

export const tableTdIconStyles1 = {
    cursor: 'pointer',
    marginTop: 3,
    marginLeft: 5,
    marginRight: 5,
    fontSize: 22
}